// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2Yqie","tab":"ProcedureTabs_tab__3aV-2"};